var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"custom-checkbox"},[_c('input',{ref:"checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"input":_vm.updateInput}}),_c('span'),(_vm.slotPassed)?_c('p',{staticClass:"checkbox-text"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }